import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useCallback, useRef, useState } from 'react';

/**
 * Per requirements GP-10/11, this dialog allows users to manually override the values in Calculation Products or its results
 */
export const CalcOvrdDialog = ({ data, closeDialog }) => {
  const [editedRows, setEditedRows] = useState([]);

  const [saving, setSaving] = useState(false);
  const rsrc = useRsrc();

  const entityEntryPoint = data.entityEntryPoint;

  const entityListRef = useRef();
  const clientSideRowData = useCallback((setDataSource) => {
    const rowsReq = {
      entityEntryPoint: entityEntryPoint,
    };

    if (entityEntryPoint === 'CALC_PROD') {
      rowsReq.calcProdId = data.calcProdIds;
    } else if (entityEntryPoint === 'CALC_PROD_RES') {
      rowsReq.calcProdId = data.calcProd.id;
    }

    rsrc.data('gp', 'CALC_PROD_OVRD_DATA_PLUGIN', rowsReq).then((rows) => {
      setDataSource(rows);
    });
  }, []);

  const augFieldDefs = useCallback((fieldToFieldDef) => {
    const columns =
      entityEntryPoint === 'CALC_PROD' ?
        ['ndc11', 'productName', 'value', 'ovrdValue', 'ovrdComment']
      : ['code', 'name', 'value', 'ovrdValue', 'ovrdComment'];

    if (entityEntryPoint === 'CALC_PROD') {
      fieldToFieldDef.ndc11 = {
        field: 'ndc11',
        maxWidth: 200,
      };

      fieldToFieldDef.productName = {
        field: 'productName',
      };
    }

    fieldToFieldDef.ovrdValue.editable = true;
    fieldToFieldDef.ovrdComment.editable = true;

    Object.keys(fieldToFieldDef).forEach((colName) => {
      if (!columns.includes(colName)) {
        delete fieldToFieldDef[colName];
      } else {
        const index = columns.indexOf(colName);
        fieldToFieldDef[colName].precedence = (index + 1) * 100;
      }
    });
  });

  const handleCellEdit = (event) => {
    const { data: row, colDef, newValue, api } = event;

    if (colDef.field === 'ovrdValue' && isNaN(newValue)) {
      api.forEachNode((node) => {
        if (row.id === node.data?.id) {
          node.setDataValue('ovrdValue', null);
          return;
        }
      });
    }

    setEditedRows((prev) => {
      const key = row.id;
      return {
        ...prev,
        [key]: {
          id: row.id,
          ovrdValue: row.ovrdValue,
          ovrdComment: row.ovrdComment,
        },
      };
    });
  };

  const handleSubmit = () => {
    //setSaving(true);

    const calcProdRess = Object.values(editedRows);
    if (calcProdRess.length === 0) {
      closeDialog();
      return;
    }

    calcProdRess.forEach((calcProdRes) => {
      calcProdRes.metaEntity = 'CALC_PROD_RES';
    });

    rsrc.save('gp', 'CALC_PROD_RES', calcProdRess).then((res) => {
      setSaving(false);

      closeDialog();
      return;
    });
    console.log(editedRows);
  };

  return (
    <Dialog
      onClose={closeDialog}
      open
      fullWidth
      maxWidth="xl"
      slotProps={{
        paper: {
          sx: {
            height: '60%',
            maxHeight: '60%',
            width: '80%',
            maxWidth: '80%',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h5">Override Values</Typography>
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', marginTop: 1, gap: 2 }}>
        <TextField value={data.calc.name} label={'Calculation Name'} disabled={true} />

        <EntityList
          //key={isSrcCalc}
          entity="CALC_PROD_RES"
          clientSideRowData={clientSideRowData}
          augFieldDefs={augFieldDefs}
          ref={entityListRef}
          events={{ onCellValueChanged: handleCellEdit }}
        />
      </DialogContent>

      <DialogActions>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Button sx={{ minWidth: 120 }} onClick={closeDialog} disabled={saving}>
            Close
          </Button>

          <Button sx={{ minWidth: 120 }} onClick={handleSubmit} disabled={saving}>
            {' '}
            Submit
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
